import { render, staticRenderFns } from "./Dirigentes.vue?vue&type=template&id=5ee6a5af&scoped=true"
import script from "./Dirigentes.vue?vue&type=script&lang=js"
export * from "./Dirigentes.vue?vue&type=script&lang=js"
import style0 from "./Dirigentes.vue?vue&type=style&index=0&id=5ee6a5af&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee6a5af",
  null
  
)

export default component.exports